module.exports = __webpack_public_path__ + "img/contact-method-3.498fc1fc.png";